import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { MESSAGES, TITLES } from "./vendorPSLineGSTMapping.constants";

function VendorPSLineGSTMappingDeleteModal({ConfirmDeleteRow,deleteOpen,CloseModal}) {
  return (
    <Modal onClose={CloseModal} open={deleteOpen} size="mini">
      <Modal.Header>{TITLES.confirmDeletion || "Confirm Deletion"}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>{MESSAGES.confirmDelete || "Are you sure you want to delete?"}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          size="mini"
          type="button"
          onClick={CloseModal}
        >
          {"cancel"}
        </Button>
        <Button type="button" size="mini" color="blue" onClick={ConfirmDeleteRow}>
          {"ok"}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default VendorPSLineGSTMappingDeleteModal;
